import React, { Fragment } from "react";
import { Col } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { SEARCH_PRODUCTS } from "../../store/actions/cart";
import Loader from "../../Layout/Loader";
import { withTranslation } from "react-i18next";
import { DEFAULT_LANGUAGE, onCollapseToggle } from "../../store/actions/layout";
import AutoCompleted from "./AutoCompleted";

const mapStateToProps = (state) => {
  return {
    searchedProductsListat: state.Cart.searchedProductsListat,
    defaultLanguage: state.Layout.defaultLanguage,
    collapsefilter: state.Layout.collapsefilter,
    userId: state.Auth.userId,
    filterProductItem: state.Product.filterProductItem,
    selectedWarehouse: state.Cart.selectedWarehouse,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    SEARCH_PRODUCTS: (payload) => dispatch(SEARCH_PRODUCTS(payload)),
    DEFAULT_LANGUAGE: (payload) => dispatch(DEFAULT_LANGUAGE(payload)),
    onCollapseToggle: (payload) => dispatch(onCollapseToggle(payload)),
  };
};

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchFilter: "",
      searchField: window.location.pathname === "/products",
      isLoading: false,
      hasSearched: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;

    if (location.pathname === "/products" && !this.state.hasSearched) {
      this.onSearch();
      this.setState({ hasSearched: true, searchField: true });
    }

    if (
      prevProps.location.pathname === "/products" &&
      location.pathname !== "/products"
    ) {
      this.setState({ hasSearched: false, searchField: false });
    }
  }

  onSearch = () => {
    const { userId, defaultLanguage } = this.props;
    const filters = {
      searchFilter: this.state.searchFilter,
      warehouse: localStorage.getItem("stockWarehouse") || 1,
      lang: defaultLanguage,
      userId: userId,
    };

    localStorage.setItem("searchFilterText", this.state.searchFilter);

    this.setState({ isLoading: true });
    this.props.SEARCH_PRODUCTS(filters).finally(() => {
      this.setState({ isLoading: false });
    });

    if (this.props.location.pathname !== "/products") {
      this.props.history.push("/products?s=true");
    }
  };

  onSelectSearch = (value) => {
    const { userId, defaultLanguage } = this.props;
    const filters = {
      searchFilter: value,
      warehouse: localStorage.getItem("stockWarehouse") || 1,
      lang: defaultLanguage,
      userId: userId,
    };
    localStorage.setItem("searchFilterText", filters.searchFilter);

    this.setState({ isLoading: true });
    this.props.SEARCH_PRODUCTS(filters).finally(() => {
      this.setState({ isLoading: false, searchFilter: "" });
    });

    if (this.props.location.pathname !== "/products") {
      this.props.history.push("/products");
    }
  };

  onChange = (name, value) => {
    this.setState({ [name]: value });
  };

  render() {
    const { isMobile, filterProductItem } = this.props;
    return (
      <Fragment>
        {this.state.isLoading && <Loader />}
        {isMobile && window.innerWidth < 700 ? (
          <Col xs={1} sm={1} md={2} lg={2} xl={2} className="px-0">
            <div style={{ position: "relative", height: "34px" }}>
              {this.state.searchField && (
                <div className="mobileSearch">
                  <AutoCompleted
                    onSearch={this.onSearch}
                    filterProductItem={filterProductItem}
                    setValue={this.onChange}
                    onSelectSearch={this.onSelectSearch}
                    isMobile={isMobile}
                  />
                </div>
              )}
            </div>
          </Col>
        ) : (
          <div className="top-search-box">
            <AutoCompleted
              onSearch={this.onSearch}
              filterProductItem={filterProductItem}
              setValue={this.onChange}
              onSelectSearch={this.onSelectSearch}
              isMobile={isMobile}
            />
          </div>
        )}
      </Fragment>
    );
  }
}
export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Search))
);
